import { Button, Menu, Text } from "@mantine/core";
import { t } from "i18next";
import { MdArrowForwardIos } from "react-icons/md";
import { TOption } from "../../dashboard/Dashboard";

type TDropDown = {
  label?: string;
  value: string;
  options: TOption[];
  disable?: boolean;
  onSelect: (val: string) => void;
  rightIcon?: JSX.Element;
};

const DropDown = ({
  label,
  value,
  options,
  disable,
  onSelect,
  rightIcon = <MdArrowForwardIos style={{ rotate: "90deg" }} />,
}: TDropDown) => {
  return (
    <Menu withArrow shadow="md" width={220}>
      <Menu.Target>
        <Button
          variant="outline"
          color="gray"
          radius="xl"
          size="lg"
          rightIcon={rightIcon}
          style={{
            color: " #343a40",
          }}
        >
          {label && (
            <Text fz="md" fw={400} mr={"xs"}>
              {t(label).toString()}:
            </Text>
          )}
          <Text fz="sm" fw={400}>
            {t(value).toString()}
          </Text>
        </Button>
      </Menu.Target>

      <Menu.Dropdown>
        {options.map((option) => (
          <Menu.Item
            disabled={disable || option.value === value}
            key={option.key}
            onClick={() => onSelect(option.key)}
          >
            {t(option.value).toString()}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
};

export default DropDown;
